"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBoundaryDefinitionTypesSchema = void 0;
const zod_1 = require("zod");
const IConnectionBoundaryDefinition_1 = require("./IConnectionBoundaryDefinition");
const INumericalBoundaryDefinition_1 = require("./INumericalBoundaryDefinition");
exports.IBoundaryDefinitionTypesSchema = zod_1.z.lazy(() => zod_1.z.discriminatedUnion('type', [INumericalBoundaryDefinition_1.INumericalBoundaryDefinitionSchema, IConnectionBoundaryDefinition_1.IConnectionBoundaryDefinitionSchema]));
//# sourceMappingURL=BoundaryDefinitionTypes.js.map